<template>
    <teleport to="#modal">
        <CercaModal v-if="cercaModalVisibility"
                    @reject="cercaModalVisibility = false"
                    @confirm="cerca"
        ></CercaModal>
    </teleport>

    <div class="hidden h-next-top bg-white lg:flex items-center justify-between max-w-screen-2xl m-auto">

        <router-link :to="{name:'Dashboard'}"><img src="@/assets/Next_logo.svg" class="h-12"></router-link>
        <div class="basis-1/2 flex items-center justify-center relative">
            <i class="icon-lente absolute left-0 ml-3"></i>
            <input @keyup.enter="cerca({text:search})" v-model="search" class="flex-grow bg-next-light-gray p-2 pl-10" placeholder="Cerca">
            <i @click="cercaModalVisibility = !cercaModalVisibility"
               class="pl-2 fa fa-sliders-h hover:text-next-orange cursor-pointer"></i>
        </div>
        <div class="pl-10">
        </div>

    </div>
    <div class="lg:hidden bg-white">
        <div class="flex justify-between">
            <img src="@/assets/Next_logo.svg" class="py-3" style="height: 75px">
            <i class="fas fa-bars self-center text-3xl" @click="toggle"></i>
        </div>

        <div class="flex justify-between pb-5">
            <div class="min-w-0 flex items-center justify-center relative">
                <i class="icon-lente absolute left-0 ml-3"></i>
                <input @keyup.enter="cerca({text:search})" v-model="search" class="self-stretch min-w-0 bg-next-light-gray p-2 pl-10" placeholder="Cerca">
            </div>
            <router-link :to="{name:'NuovoCliente'}"
                         class="bg-next-orange border-2 border-next-orange text-white hover:bg-transparent hover:text-next-orange py-2 px-4 m-0 hidden sm:flex items-center">
                + Aggiungi
            </router-link>
            <router-link :to="{name:'NuovoCliente'}"
                         class="bg-next-orange border-2 border-next-orange text-white hover:bg-transparent hover:text-next-orange py-2 px-4 m-0 flex sm:hidden items-center">
                <i class="fa fa-plus text-2xl"></i>
            </router-link>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import CercaModal from "@/views/CercaModal.vue";

@Options({
    name:'TopbarProgetti',
    components: {CercaModal},
    props: {}
})
export default class TopbarProgetti extends Vue {
    $store: any;
    cercaModalVisibility = false
    search = ''

    toggle() {
        this.$store.commit('toggle_menu')
    }

    cerca(data: any) {
        //@ts-ignore
        this.$router.push({name: 'Search', query: data})
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
